import type { ReactNode } from 'react';

/* Small building blocks shared by the Minions cards. */

/** The "KPI 3" tag after a label — the Minions Spec §15 number. */
export const Kpi = ({ n }: { n: string }) => <span className="mn-kpi">KPI {n}</span>;

export const Tile = ({ label, kpi, value, sub }: { label: string; kpi?: string; value: string; sub?: ReactNode }) => (
  <div className="mn-tile">
    <span className="mn-tile-l">
      {label}
      {kpi && <Kpi n={kpi} />}
    </span>
    <span className="mn-tile-v">{value}</span>
    {sub && <span className="mn-tile-s">{sub}</span>}
  </div>
);

export const Stat = ({ label, value, blue, pending, sub }: { label: string; value: string; blue?: boolean; pending?: boolean; sub?: ReactNode }) => (
  <div className="mn-stat">
    <span className="mn-stat-l">{label}</span>
    <span className={`mn-stat-v${blue ? ' blue' : ''}${pending ? ' pending' : ''}`}>{value}</span>
    {sub && <span className="mn-tile-s">{sub}</span>}
  </div>
);

/** A thin bar filled to a share (0–100); empty when unknown. */
export const Track = ({ pct, tone }: { pct: number | null; tone?: 'yellow' | 'ink' | 'blue2' }) => (
  <div className="mn-track">
    {pct != null && <div className={`mn-fill${tone ? ` ${tone}` : ''}`} style={{ width: `${Math.max(0, Math.min(100, pct))}%` }} />}
  </div>
);
